import { render, staticRenderFns } from "./LoanAdvanceNotificationSettings.vue?vue&type=template&id=ddf32870"
import script from "./LoanAdvanceNotificationSettings.vue?vue&type=script&lang=js"
export * from "./LoanAdvanceNotificationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports